

// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // apiUrl: `http://192.168.0.102:3501`,
  apiUrl: 'https://front-timer-c3-api.up.railway.app',
  firebaseConfig: {
    apiKey: "AIzaSyA_NMBOwHLKZ_SURxXB3XIn05jrL7wjgdg",
    authDomain: "front-timer-c3.firebaseapp.com",
    projectId: "front-timer-c3",
    storageBucket: "front-timer-c3.firebasestorage.app",
    messagingSenderId: "924925630483",
    appId: "1:924925630483:web:97659f99621a7d6efd47e6"
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
